"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButterflyEffect = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const ShiftAresGlobalParametersDeferred_1 = require("../../deferredActions/ShiftAresGlobalParametersDeferred");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Size_1 = require("../render/Size");
const AresHandler_1 = require("../../ares/AresHandler");
const IAresData_1 = require("../../ares/IAresData");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const constants_1 = require("../../constants");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const Units_1 = require("../../Units");
class ButterflyEffect extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.BUTTERFLY_EFFECT,
            cost: 8,
            tr: { tr: 1 },
            metadata: {
                cardNumber: 'A03',
                description: 'Gain 1 TR. Move each individual hazard marker up to 1 step up or down.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.tr(1).br;
                    b.plate('All hazard markers').colon().text('-1 / 0 / +1', Size_1.Size.SMALL);
                }),
            },
        });
    }
    canPlay(player) {
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this);
        if (!super.canPlay(player))
            return false;
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        this.howToAffordReds = undefined;
        return true;
    }
    play(player) {
        player.increaseTerraformRatingSteps(1);
        AresHandler_1.AresHandler.ifAres(player.game, (aresData) => {
            const hazardData = aresData.hazardData;
            if (IAresData_1.HAZARD_CONSTRAINTS.some((constraint) => hazardData[constraint].available === true)) {
                player.game.defer(new ShiftAresGlobalParametersDeferred_1.ShiftAresGlobalParametersDeferred(player));
            }
            else {
                player.game.log('All hazard markers have already been reached.');
            }
        });
        return undefined;
    }
    getActionDetails(_player, card) {
        return new RedsPolicy_1.ActionDetails({ card: card, TRIncrease: 1 });
    }
}
exports.ButterflyEffect = ButterflyEffect;
//# sourceMappingURL=ButterflyEffect.js.map